import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Data/Products/Handlers/LoadProductByPath";

// Remove "includeOnProduct" from includeAttributes so the API returns ALL attributes.
// The includeOnProduct filter is applied at the frontend level in ProductDetailsAttributes.tsx
// based on isVariantParent, so parent variants hide attributes and child variants show all.
const CustomPopulateApiParameter: typeof PopulateApiParameter = props => {
    props.apiParameter = {
        ...props.parameter,
        expand: ["detail", "specifications", "content", "images", "documents", "attributes", "variantTraits", "badges"],
        includeAttributes: ["notFromCategory"],
    };
};

replaceInChain(chain, PopulateApiParameter, CustomPopulateApiParameter);
